import fonts from './fonts'

const textStyles = {
  H1: `
    ${fonts.MontserratBold}
    font-size: 3rem;
    text-transform: uppercase;
    line-height: initial;
  `,
  H2: `
    ${fonts.MontserratBold}
    font-size: 2.6rem;
    line-height: initial;
    text-transform: uppercase;
  `,
  H3: `
    ${fonts.MontserratBold}
    font-size: 2.4rem;
    line-height: initial;
  `,
  H4: `
    ${fonts.MontserratBold}
    font-size: 2rem;
    line-height: initial;
  `,
  H5: `
    ${fonts.MontserratMedium}
    font-size: 1.8rem;
    line-height: initial;
  `,
  H6: `
    ${fonts.MontserratBold}
    font-size: 1.4rem;
    line-height: initial;
  `,
  textVeryLargeStrong: `
    ${fonts.MontserratMedium}
    font-size: 1.8rem;
    line-height: initial;
  `,
  textLargeStrong: `
    ${fonts.MontserratMedium}
    font-size: 1.6rem;
    line-height: initial;
  `,
  textLarge: `
    ${fonts.MontserratRegular}
    font-size: 1.6rem;
    line-height: initial;
  `,
  textMedium: `
    ${fonts.MontserratRegular}
    font-size: 1.4rem;
    line-height: normal;
  `,
  text: `
    ${fonts.MontserratRegular}
    font-size: 1.2rem;
    line-height: 1.5;
  `,
  textSmallStrong: `
    ${fonts.MontserratMedium}
    font-size: 1.2rem;
    line-height: normal;
  `,
  textSmall: `
    ${fonts.MontserratRegular}
    font-size: 1.2rem;
    line-height: normal;
  `,
  textTiny: `
    ${fonts.MontserratRegular}
    font-size: 0.8rem;
    line-height: normal;
  `,
}

export default textStyles
